export default "__VITE_ASSET__DQVjkND7__"